<script setup lang="ts">
import { ref, defineProps, defineEmits } from 'vue'
import { http } from '../composables/http'

const { customer } = defineProps(['customer'])
const emits = defineEmits(['onSaveContact'])

const value = ref('')

const create = async () => {
  if (!customer?.id) {
    return emits('onSaveFail', 'Cliente não selecionado')
  }

  const resp = await http(`/contacts`, {
    method: 'POST',
    body: JSON.stringify({
      contact: {
        value: value.value,
        customer_id: customer?.id
      }
    })
  })
  if (resp.error) {
    emits('onSaveFail', resp.erro || 'Erro ao salvar!')
  } else {
    value.value = ''
    customer.value = null
    emits('onSaveSuccess')
  }
}
const enrichment = async () => {
  if (!customer?.id) {
    return emits('onSaveFail', 'Cliente não selecionado')
  }
  if (!customer?.document) {
    return emits('onSaveFail', 'Cliente sem cpf definido')
  }

  const resp = await http(
    `/customers/${customer?.id}/enrichment/${customer?.document.replace(/\D/g,'')}`, { method: 'PATCH' }
  )
  if (resp.error) {
    emits('onSaveFail', resp.erro || 'Erro ao pedir novos contatos!')
  } else {
    value.value = ''
    customer.value = null
    emits('onSaveSuccess')
  }
}
</script>

<template>
  <div class="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-4">
    <label v-if="customer?.id" class="w-full max-w-sm">Cliente: {{ customer.name }}</label>

    <label v-if="customer?.id" class="w-full max-w-sm">Unidade: {{ customer.company.name }}</label>

    <form @submit.prevent="create" class="w-full max-w-sm">
      <input type="text" id="phone-number" placeholder="telefone" v-model="value" class="rounded-md py-3 px-4 border-gray-200 shadow-sm rounded-s-lg text-sm focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600">
      <button type="submit" class="w-[2.875rem] h-[2.875rem] shrink-0 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-e-md border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">
        <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path
            d="M0,10 h80 M10,0 v20 M25,0 v20 M40,0 v20 M55,0 v20 M70,0 v20"
            fill="none"/>
        </svg>
      </button>
    </form>
    <form @submit.prevent="enrichment" class="w-full max-w-sm">
      <input type="text" id="customer-document" placeholder="cpf" v-model="customer.document" class="rounded-md focus:ring border-gray-200 ">
      <button type="submit" class="w-[2.875rem] h-[2.875rem] shrink-0 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-e-md border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">
        <svg class="shrink-0 size-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 18">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 14 3-3m-3 3 3 3m-3-3h16v-3m2-7-3 3m3-3-3-3m3 3H3v3"></path>
        </svg>
      </button>
    </form>
  </div>
</template>
